import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const HealthiestFoodRoot = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: '$tertiary-200',
  width: '100%',
  borderTop: 0,
  borderBottom: '12px solid transparent',
  borderImage: 'url(/assets/pattern-footer-border-mobile.svg) 30',

  '@bp2': {
    borderImage: 'url(/assets/pattern-footer-border-desktop.svg) 30',
  },
})

export const Wrapper = styled('div', {
  width: '100%',
  maxWidth: '$max',
  backgroundColor: '$tertiary-200',
  padding: '$6 $3 $7',

  '@bp1': {
    padding: '$6 $6 $7',
  },

  '@bp3': {
    padding: '152px 260px',
  },
})

export const Title = styled('div', {
  maxWidth: '380px',
  alignSelf: 'center',

  '@bp2': {
    maxWidth: '540px',
  },
})

export const TextWrapper = styled('div', {
  flex: 1,
  display: 'flex',
  alignSelf: 'flex-end',
  flexDirection: 'column',
})

export const Description1 = styled(Text, {
  '@bp2': {
    flex: 1,
    order: 2,
    paddingLeft: '$6',
  },

  '@bp3': {
    paddingLeft: '$14',
  },
})
